import { useState } from "react";

// import axios from 'axios'
import { useDispatch, useSelector } from "react-redux"
import marvarApi from "../../../../api/marvarApi"
import { onLogout } from "store"

import { useHelpers } from './useHelpers';
import { useGlobalStates } from './useGlobalStates';
import { useDefaultData } from './useDefaultData';
import { useForm } from './useForm';
import * as useFetchData from './useFetchData';
import { useActions } from './useActions';

export const useFechInitVehicleCatalog = ({location, paramsURL}) => {

    const dispatch = useDispatch()

    const helpers = useHelpers()

    
    const { user } = useSelector((state) => state.auth)

    // globalStates -------------------------------------------------------------------------------
    const globalStates = useGlobalStates()

    // defaultData --------------------------------------------------------------------------------
    const defaultData = useDefaultData({helpers})

    // Para la modal -------------------------------------------------------
    const { defaultDataModal } = defaultData
    const [ dataModal, setDataModal ] = useState(defaultDataModal)
    const toggle = (_, title, compont, dataRequest) => {
        setDataModal({
            ...defaultDataModal,
            open: !dataModal.open,
            titleModal: title,
            componentModal: compont,
            dataRequest: dataRequest
        })
    }   

    const FormVehicle = useForm(defaultData.defaultFormVehicle)
    const FormExpenses = useForm(defaultData.defaultFormExpenses)
    const FormStatus = useForm(defaultData.defaultFormStatus)
    const FormAdvance = useForm(defaultData.defaultFormAdvance)
    

    const Forms = {
        FormVehicle,
        FormExpenses,
        FormStatus,
        FormAdvance,
    }


    const defaultFetchParams = { 
        //------------- Generales
        marvarApi, user, dispatch, onLogout, location, paramsURL,
        //------------- globalStates
        // globalStates,
        //------------- defalutData
        defaultData, 
        //------------- Helpers
        helpers,
        //------------- Forms
        Forms 
    }



    const fetchAllVehicles = useFetchData.useFetchAllVehicles({...defaultFetchParams})
    const fetchInfoVehicle = useFetchData.useFetchInfoVehicle({...defaultFetchParams})
    const fetchVehicleImages = useFetchData.useFetchVehicleImages({...defaultFetchParams})
    const fetchVehicleExpenses = useFetchData.useFetchAllVehicleExpenses({...defaultFetchParams})
    const fetchInfoExpenses = useFetchData.useFetchInfoExpense({...defaultFetchParams})
    const fetchAllStatus = useFetchData.useFetchAllVehicleStatus({...defaultFetchParams})
    const fetchInfoStatus = useFetchData.useFetchInfoStatus({...defaultFetchParams})
    const fetchAllAdvance = useFetchData.useFetchAllAdvance({...defaultFetchParams})

    const FetchData = {
        fetchAllVehicles,
        fetchInfoVehicle,
        fetchVehicleImages,
        fetchVehicleExpenses,
        fetchInfoExpenses,
        fetchAllStatus,
        fetchInfoStatus,
        fetchAllAdvance,
    }

    const Actions = useActions({
        marvarApi, toggle, user,
        FetchData,
        globalStates,
        defaultData,
        Forms,
        helpers
    })

    return Object.freeze({
        //------------- Generales
        dataModal, toggle, user,
        globalStates,
        defaultData,
        FetchData,
        Forms,
        Actions
    })

}